"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CurrentCustomer = void 0;
class CurrentCustomer {
    static id;
    static instance;
    constructor() { }
    static getInstance() {
        if (!CurrentCustomer.instance) {
            CurrentCustomer.instance = new CurrentCustomer();
        }
        return CurrentCustomer.instance;
    }
    updateId(customerId) {
        if (customerId === '') {
            throw new Error("Don't update with an empty string");
        }
        CurrentCustomer.id = customerId;
    }
    getId() {
        return CurrentCustomer.id;
    }
    reset() {
        CurrentCustomer.id = undefined;
    }
}
exports.CurrentCustomer = CurrentCustomer;
//# sourceMappingURL=CurrentCustomer.js.map